import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import { saveDate } from "../../dateSlice";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
// import { tenant } from "../../tenant"; // No longer needed for REST endpoints
import showToast from "../../utils/toast";
import GenericFileInput from "../genericFileInput";
import "./CalendarStyles.css";
// GraphQL import removed - now using REST endpoint
import Button from "@mui/material/Button";
export default function JournalVerbal() {
	const authContext = useContext(AuthContext);

	const dispatch = useDispatch();
	const savedState = useSelector((state) => {
		return state.date;
	});
	const [state, setState] = useState(savedState);

	const [typeOption, setTypeOption] = React.useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingFile, setLoadingFile] = useState(false);
	const [files, setFiles] = useState([]);
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);

	const apiUrl = "/journal-verbal-managment/";

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	const handleDateChange = (newDate) => {
		setState((prevState) => ({ ...prevState, date: newDate }));
		dispatch(saveDate({ date: newDate })); // Aggiorna la data selezionata
		setLoading(true);
		setIsCalendarOpen(false);
	};

	const tileDisabled = ({ date }) => {
		const today = new Date();
		// Disabilita le date future
		return date > today;
	};

	useEffect(() => {
		apiService
			.get("/attachment-types/", {
				use_on_attachments_area: "false",
			})
			.then((data) => {
				if (data && Array.isArray(data)) setTypeOption(data);
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento dei tipi. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #01441654549"
				);
			});
	}, []);

	function getAttachments() {
		setLoading(true);
		apiService
			.get(
				"/journal-verbal-managment",
				{
					area_id: localStorage.getItem("areaSelected"),
					date: dayjs(state.date).format("YYYY-MM-DD"),
					tenant:
						window.location.hostname.split(".")[0] !== "localhost"
							? process.env.REACT_APP_API_URL_BACKEND
							: "http://bottoli.localhost:8000",
				},
				{}
			)
			.then((data) => {
				setFiles(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				handleSetNotification(
					"Qualcosaè andato storto durante il caricamento dei file. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0144125625335",
					"error"
				);
			});
	}

	useEffect(() => {
		getAttachments();
	}, [state.date]);

	const handleSubmit = (fileInfos) => {
		setLoadingFile(true);
		const formData = {
			files: fileInfos,
			date: dayjs(state.date).format("YYYY-MM-DD"),
			area_id: localStorage.getItem("areaSelected"),
		};
		apiService
			.post(apiUrl, {}, formData)
			.then((data) => {
				handleSetNotification("Dati salvati con successo!", "success");
				getAttachments();
				setLoadingFile(false);
			})
			.catch((error) => {
				setLoadingFile(false);
				handleSetNotification(
					"Qualcosaè andato storto durante il salvataggio. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #011112532335",
					"error"
				);
			});
	};

	const inputFields = [
		{ type: "text", name: "verbal_number", label: "Numero verbale" },
		{
			type: "select",
			name: "type",
			label: "Tipologia documento",
			options: typeOption,
		},
	];

	return (
		<>
			<DashboardLayout>
				<DashboardNavbar />
				{authContext.hasAuth("VIEW_VERBALAREA") ? (
					<>
						<center style={{ marginBottom: "25px" }}>
							<div className="calendar-container">
								<div style={{ display: !isCalendarOpen ? "none" : "block" }}>
									<Calendar
										onChange={handleDateChange}
										value={state.date}
										tileDisabled={tileDisabled}
										maxDate={new Date()}
										className="custom-calendar"
									/>
								</div>
								<div
									style={{
										marginTop: "16px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "16px",
										flexWrap: "wrap",
										marginBottom: "30px",
									}}
								>
									<Button
										onClick={() => setIsCalendarOpen(!isCalendarOpen)}
										variant="contained"
										color="primary"
										sx={{
											minWidth: "120px",
											color: "#ffffff",
										}}
									>
										{isCalendarOpen ? "Chiudi calendario" : "Apri calendario"}
									</Button>
									<MDTypography fontWeight="bold" textTransform="uppercase">
										{state.date.toLocaleDateString("it-IT", {
											weekday: "long",
											year: "numeric",
											month: "2-digit",
											day: "2-digit",
										})}
									</MDTypography>
								</div>
							</div>
						</center>
						{!loading && !loadingFile ? (
							<GenericFileInput
								onSubmit={handleSubmit}
								inputFields={inputFields}
								authModelName={"VERBALAREA"}
								files={files}
							/>
						) : (
							<center>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<CircularProgress size={80} sx={{ marginTop: "50px" }} />
									<text>L'operazione potrebbe richiedere alcuni minuti...</text>
								</div>
							</center>
						)}
					</>
				) : (
					<MDAlert color="error" dismissible>
						<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
					</MDAlert>
				)}
			</DashboardLayout>
		</>
	);
}
